export default "__VITE_ASSET__CQnpZ1Sq__"